/* globals $ */
import { registerClass } from 'libs/ComponentLoader'

import './styles.scss'

export const OPTION_CHANGED = 'VariantOptionSelector:option_changed'

class VariantOptionSelector {
  constructor (element) {
    this.$el = $(element)

    this.$options = this.$el.find('.variantOptionSelector-radio')

    this.$options.on('change', this.onOptionChange.bind(this))
  }

  onOptionChange (e) {
    this.$el.trigger(OPTION_CHANGED, [$(e.currentTarget).val()])
  }

  selectedOption () {
    return {
      value: this.$options.filter(':checked').val(),
      index: this.$el.attr('data-index')
    }
  }
}

registerClass('VariantOptionSelector', VariantOptionSelector)
